import { DateTime } from 'luxon'

const mapClassPrefixesWithSuffix = (prefixes: string[], suffix: string) => {
  return prefixes.map((p) => `${p}${suffix}`).join(' ')
}

const isWeekday = (d: DateTime) => d.weekday >= 1 && d.weekday <= 5

const formatCentsToUSD = (cents: number): string => {
  const dollars = cents / 100
  return dollars.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: dollars % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  })
}

const suffixForDateNumber = (day: number) => {
  if (day >= 11 && day <= 13) {
    return 'th'
  }

  const lastDigit = day % 10

  switch (lastDigit) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

export const ComponentUtils = {
  formatCentsToUSD,
  isWeekday,
  mapClassPrefixesWithSuffix,
  suffixForDateNumber,
}
